<template>
  <div class="header">
    <div class="left-container">
      <img src="@/assets/images/footer.png" class="img-class" />
      <div class="left-text">
        <div class="company">生诺医药</div>
        <div class="english-text">SINORDA<br />BIOMEDICINE</div>
      </div>
    </div>
    <div class="header-navbar-list">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        active-text-color="#909399"
        text-color="#000"
        router
      >
        <el-menu-item index="/" router>{{ $t("menu.Home") }}</el-menu-item>
        <el-menu-item index="companyIntroduce" router>{{
          $t("menu.aboutUs")
        }}</el-menu-item>
        <el-submenu index="product" popper-class="popper">
          <template slot="title">{{ $t("menu.productPipeline") }}</template>
          <el-menu-item index="product" router>{{
            $t("menu.pipeline")
          }}</el-menu-item>
          <el-menu-item index="process" router>{{
            $t("menu.productCenter")
          }}</el-menu-item>
          <el-menu-item index="publication">{{
            $t("menu.scientific")
          }}</el-menu-item>
        </el-submenu>
        <el-menu-item index="technicalPlatform">{{
          $t("menu.platform")
        }}</el-menu-item>
        <!-- <el-menu-item index="medicalService">{{
          $t("menu.service")
        }}</el-menu-item> -->
        <el-submenu popper-class="popper" index="title">
          <template slot="title">{{ $t("menu.news") }}</template>
          <el-menu-item index="newsCenter" router>{{ $t("menu.companyNews") }}</el-menu-item>
          <el-menu-item index="industryNews" router>{{ $t("menu.tradeNews") }}</el-menu-item>
        </el-submenu>
        <el-menu-item index="talentRecruitment">{{
          $t("menu.recruitment")
        }}</el-menu-item>
        <el-menu-item index="contractUs">{{
          $t("menu.contactUs")
        }}</el-menu-item>
      </el-menu>
    </div>
    <div class="right-text">
      <div class="right-item">|</div>
      <div class="right-item click-item" @click="changeChinese('en')">EN</div>
      <div class="click-item" @click="changeChinese('zh')">中文</div>
      
    </div>
    
  </div>
</template>
<script>
import { routes } from "@/router";
// import { mapState } from "vuex";
export default {
  name: "headerCom",
  data() {
    return {
      activeIndex: "homePage",
      // 顶部栏初始数
      visibleNumber: 5,
      routes: routes,
      menuList: [
        {
          firstTitle: "首页",
        },
        {
          firstTitle: "关于我们",
        },
        {
          firstTitle: "产品研发",
        },
        {
          firstTitle: "技术平台",
        },
        {
          firstTitle: "新闻中心",
        },
      ],
    };
  },
  computed: {
    // ...mapState({
    //   userInfo: (state) => state.app.userInfo,
    // }),
    curIndex: {
      get() {
        return this.$route.path;
      },
      set(val) {
        return val;
      },
    },
    // userName() {
    //   return this.$store.state.app.userInfo.name;
    // },
  },
  beforeMount() {
    window.addEventListener("resize", this.setVisibleNumber);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setVisibleNumber);
  },
  mounted() {
    this.setVisibleNumber();
  },
  methods: {
    changeChinese(command) {
      this.$i18n.locale = command;
      localStorage.setItem("lang", command);
      if (command == "en") {
        this.language = "English";
      } else if (command == "zh") {
        this.language = "中文";
      }
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      console.log("keyPath: ", keyPath);
    },
    // 根据宽度计算设置显示栏数
    setVisibleNumber() {
      const width = document.body.getBoundingClientRect().width * 0.9;
      this.visibleNumber = parseInt(width / 130);
    },
    navClick(row, index) {
      this.activeIndex = index;
      this.curIndex = index;
      if (row.type == "router") {
        this.$router.push({ path: row.url });
      } else {
        // 此处跳转不加refer
        window.open(row.url, "_brank", "noopener,noreferrer,resizable");
      }
    },
    goToSign() {
      this.$router.push(`/login`);
      // window.location.href =
      // "https://www.jszwfw.gov.cn/jsjis/front/login.do?uuid=MMQZVHY6kZZ9&gotoUrl=fymfb";
    },
  },
};
</script>
<style lang="scss" scoped>
body {
  margin: 0;
  padding: 0;
}
.header {
  position: sticky;
  top:0;
  z-index: 10;
  background: white;
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px;
}
.img-class {
  width: 80px;
  margin: 14px 0;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.el-dropdown + .el-dropdown {
  padding-left: 60px;
}
:deep(.el-dropdown__popper .el-dropdown-menu__item:hover),
:deep(.el-dropdown__popper .el-dropdown-menu__item.is-active) {
  background-color: red;
}
.header-navbar-list {
  // position: relative;
  // display: flex;
  // flex: 1;
  line-height: 48px;
  // white-space: nowrap;
  // span {
  //   cursor: pointer;
  //   font-size: 16px;
  //   color: #acb5e0;
  //   white-space: nowrap;
  // }
  // span + span {
  //   margin-left: 20px;
  // }
  // span.active {
  //   color: #fff;
  // }
  // .header-navbar-list-more {
  //   margin-left: 20px;
  //   position: relative;
  //   color: #acb5e0;
  //   .more {
  //     cursor: pointer;
  //     i {
  //       margin-right: 5px;
  //       transform: rotate(0deg);
  //       transition: all 0.38s;
  //     }
  //   }
  //   ul {
  //     display: none;
  //     position: absolute;
  //     z-index: 3000;
  //     padding: 5px 0;
  //     border-radius: 8px;
  //     box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  //     color: #000;
  //     min-width: 200px;
  //     top: 40px;
  //     left: -20px;
  //     li {
  //       background-color: #fff;
  //       float: none;
  //       height: 36px;
  //       line-height: 36px;
  //       padding: 0 10px;
  //       color: #000;
  //       list-style: none;
  //       box-sizing: border-box;
  //       white-space: nowrap;
  //       cursor: pointer;
  //       &:hover {
  //         color: #000;
  //       }
  //     }
  //   }
  //   &:hover ul {
  //     display: block;
  //   }
  //   &:hover .more {
  //     color: #fff;
  //   }
  //   &:hover .more i {
  //     transform: rotate(135deg);
  //     transition: all 0.38s;
  //   }
  // }
}
.register {
  margin-left: 20px;
}
// font-size: this.$i18n.locale == 'zh' ? 16px : 14px;
.header-navbar-list-item {
  cursor: pointer;
  color: #fff;
  
  margin-left: 30px;
  padding: 10px 0;
}
.nav-user-box {
  width: 120px;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 3px;
  position: absolute;
  z-index: 2000;
  right: 50%;
  transform: translate(50%, 0);
  top: 14px;
  list-style: none;
  padding: 0;
  text-align: center;
  overflow: hidden;
  //display: none;
  li {
    font-size: 16px;
    color: #000;
    line-height: 40px;
    cursor: pointer;
  }
  li:first-child {
    padding-top: 10px;
  }
  li:last-child {
    padding-bottom: 10px;
  }
  a {
    text-decoration: none;
    color: #000;
  }
  &.active {
    display: block;
  }
}
.moreActive {
  color: #fff;
}
.el-menu-item {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}
:deep(.el-menu-item),
:deep(.el-submenu__title) {
  font-size: 14px;
}
:deep(.el-menu.el-menu--horizontal) {
  border-bottom: unset;
}
:deep(.el-menu-item),
:deep(.el-menu--horizontal > .el-submenu .el-submenu__title) {
  font-weight: 600;
}

.el-menu {
  background-color: transparent !important;
}
.el-menu-item:hover {
  background: transparent !important;
}
.title-item {
  font-size: 20px;
  color: #000;
  margin-left: 18px;
}
.title-item:hover {
  font-weight: 600;
  cursor: pointer;
}
:deep(.el-menu--collapse .el-menu .el-submenu, .el-menu--popup) {
  min-width: 144px !important;
}
// .img-class {
//   width: 14%;
// }
.left-container {
  display: flex;
  align-items: center;
  // margin-left: 90px;
}
.company {
  font-size: 24px;
}
.left-text {
  font-weight: 600;
  margin-left: 20px;
}
.right-text{
  display: flex;
  width: 6%;
}
.right-item {
  margin-right: 10px;
}
.click-item:hover{
  cursor: pointer;
  color: #409eff;
}
</style>
